import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createContext, useState, useCallback } from "react";
import ErrorPopup from "@/06-shared/ui/notifyPopup";
const ErrorProvider = ({ children }) => {
    const [errorText, setErrorText] = useState(null);
    const [errorDuration, setErrorDuration] = useState(5000);
    const showError = useCallback((text, duration = 5000) => {
        setErrorText(text);
        setErrorDuration(duration);
    }, []);
    const handleClose = () => setErrorText(null);
    return (_jsxs(_ErrorContext.Provider, Object.assign({ value: { showError } }, { children: [children, errorText && (_jsx(ErrorPopup, { text: errorText, onClose: handleClose, duration: errorDuration }))] })));
};
export default ErrorProvider;
export const _ErrorContext = createContext(undefined);
